import { CreditCardType } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';
import { useMangopayCreditCardsEnabled } from 'hooks/useMangopayCreditCardsEnabled';

export const useGetCreditCardsFeesBasisPoints = () => {
  const mangopayCreditCardsEnabled = useMangopayCreditCardsEnabled();
  const {
    checkoutFeesBasisPoints,
    mangopayVisaFeesBasisPoints,
    mangopayAmexFeesBasisPoints,
  } = useConfigContext();
  return (cardType?: CreditCardType | undefined | null) => {
    if (!mangopayCreditCardsEnabled) {
      return +checkoutFeesBasisPoints;
    }
    if (CreditCardType.AMEX === cardType) return +mangopayAmexFeesBasisPoints;
    return +mangopayVisaFeesBasisPoints;
  };
};

export const useGetCreditCardFees = () => {
  const getCreditCardsFeesBasisPoints = useGetCreditCardsFeesBasisPoints();
  return (cardType?: CreditCardType | undefined | null) => {
    return getCreditCardsFeesBasisPoints(cardType) / 10000;
  };
};
